<template>
  <section class="lead-flow-overview-section lead-flow-double-requests" aria-label="Double Requests">
    <h3>
      Double Requests
      <span v-if="!error" class="lead-flow-double-requests__count">{{ count }}</span>
    </h3>
    <p v-if="error" class="lead-flow-double-requests__error" role="alert">
      Unable to load double requests.
      <button type="button" @click="$emit('retry')">Retry</button>
    </p>
    <template v-else>
      <ul>
        <li v-for="lead in items" :key="lead.id">
          <span class="lead-flow-double-requests__id">#{{ lead.id }}</span>
          <span
            v-if="lead.country && lead.country.code"
            v-tooltip="{ content: lead.country.name, placement: 'top-start', offset: 8 }"
            :class="`fflag ff-sm fflag-${lead.country.code}`"
            :aria-label="lead.country.name"
            class="lead-flow-double-requests__flag"
          ></span>
          <img
            v-else
            v-tooltip="{ content: 'Country not provided', placement: 'top-start', offset: 8 }"
            class="lead-flow-double-requests__globe"
            src="@/assets/img/globe-icon.svg"
            alt="Country not provided"
          >
          <a
            class="lead-flow-double-requests__name"
            :href="leadHref(lead)"
            target="_blank"
            rel="noopener noreferrer"
          >{{ leadName(lead) }}</a>
          <span
            v-tooltip="{ content: amountUsd(lead), placement: 'top-start', offset: 8 }"
            class="lead-flow-double-requests__amount"
          >{{ amountLabel(lead) }}</span>
          <span class="lead-flow-double-requests__manager">{{ lead.manager || 'No manager' }}</span>
        </li>
      </ul>
      <p v-if="hiddenCount > 0" class="lead-flow-double-requests__more">+{{ hiddenCount }} more</p>
    </template>
  </section>
</template>

<script>
export default {
  name: 'LeadDoubleRequests',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    count: {
      type: Number,
      default: 0
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hiddenCount() {
      return Math.max(this.count - this.items.length, 0)
    }
  },
  methods: {
    leadHref(lead) {
      return this.$router.resolve({ name: 'leads-detail-lead', params: { id: lead.id } }).href
    },
    leadName(lead) {
      return lead.name || `Lead #${lead.id}`
    },
    amountLabel(lead) {
      const amount = lead.amount
      if (!amount || amount.value === null || amount.value === undefined) return '-'
      const value = Number(amount.value).toLocaleString('en-GB')
      return amount.currency ? `${value} ${amount.currency}` : value
    },
    amountUsd(lead) {
      const usd = lead.amount && lead.amount.usd
      return usd || usd === 0 ? `${Number(usd).toLocaleString('en-GB')} USD` : ''
    }
  }
}
</script>

<style scoped>
.lead-flow-double-requests ul {
  display: grid;
  gap: 9px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.lead-flow-double-requests li {
  display: grid;
  min-width: 0;
  grid-template-columns: 92px 23px minmax(0, 1.15fr) minmax(0, .7fr) minmax(0, .85fr);
  align-items: center;
  gap: 10px;
}

.lead-flow-double-requests__count {
  margin-left: 6px;
  color: #7f8c8b;
  font-weight: 600;
}

.lead-flow-double-requests__flag {
  width: 23px;
  height: 14px;
}

.lead-flow-double-requests__globe {
  width: 18px;
  height: 18px;
}

.lead-flow-double-requests__id {
  color: #7f8c8b;
  font-size: 14px;
  font-variant-numeric: tabular-nums;
}

.lead-flow-double-requests__name {
  min-width: 0;
  overflow-wrap: anywhere;
  color: #3976ae;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
}

.lead-flow-double-requests__name:hover {
  text-decoration: underline;
}

.lead-flow-double-requests__amount {
  min-width: 0;
  overflow-wrap: anywhere;
  color: #344749;
  font-size: 14px;
  font-variant-numeric: tabular-nums;
}

.lead-flow-double-requests__manager {
  min-width: 0;
  overflow-wrap: anywhere;
  color: #344749;
  font-size: 14px;
  text-align: right;
}

.lead-flow-double-requests__more {
  margin: 9px 0 0;
  color: #7f8c8b;
  font-size: 13px;
}

.lead-flow-double-requests__error {
  margin: 0;
  color: #73413b;
  font-size: 14px;
}

.lead-flow-double-requests__error button {
  margin-left: 8px;
  padding: 0;
  border: 0;
  background: none;
  color: #925046;
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
}
</style>
